module.exports = __webpack_public_path__ + "img/3.65536d3c.png";